let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("er5Rw")).then(() => parcelRequire('ktJB5'));